/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespCollectionsModuleOld_homepage = {
    readonly collectionsModule: {
        readonly title?: string | null;
        readonly items?: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly title: string | null;
            readonly imageUrl: string | null;
            readonly linkData: {
                readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
            };
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespCollectionsModuleOld_homepage";
};
export type HpRespCollectionsModuleOld_homepage$data = HpRespCollectionsModuleOld_homepage;
export type HpRespCollectionsModuleOld_homepage$key = {
    readonly " $data"?: HpRespCollectionsModuleOld_homepage$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespCollectionsModuleOld_homepage">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "HpRespCollectionsModuleOld_homepage",
  "type": "Homepage",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "collectionsModule",
      "name": "module",
      "storageKey": "module(type:\"collections\")",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "collections"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "CollectionsModule",
          "selections": [
            (v0/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "Product",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cmsId",
                  "args": null,
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "imageUrl",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "linkData",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "LinkData",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "SeoLink_linkData",
                      "args": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'c9b9f05800aa0fe1198c09455aef737e';
export default node;
